// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3748ed82\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/postcss-loader/lib/index.js?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Spec.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("7c8cd1cd", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3748ed82","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/product/product/part/Spec.vue
// module id = 00u5
// module chunks = 0